<div class="profile-page bg-secondary">
    <main class="pt-3">
        <div class="container wow fadeIn">
            <b-row align-v="center">
                <b-col>
                    <legend>Relayed SMS</legend>
                </b-col>
                <b-col cols="auto" class="d-flex align-items-center">
                    <b-form-checkbox v-model="flaggedOnly" @change="onFilterChange" switch class="mr-3">
                        Flagged only
                    </b-form-checkbox>
                    <b-button type="button" @click="onReprocessClick" pill variant="outline-secondary" class="mr-2">
                        Reprocess
                    </b-button>
                    <b-button type="button" @click="getMessages" pill variant="outline-dark">
                        Refresh
                    </b-button>
                </b-col>
            </b-row>

            <b-row>
                <b-col>
                    <b-table striped hover responsive :items="items" :fields="fields" small>
                        <template #cell(createdOn)="data">
                            {{ data.item.createdOn | formateDate }}
                        </template>
                        <template #cell(receivedAt)="data">
                            {{ data.item.receivedAt | formateDate }}
                        </template>
                        <template #cell(deposit)="data">
                            <span v-if="data.item.bank">
                                <b-badge variant="secondary">{{ data.item.bank }}</b-badge>
                                <b-badge variant="light">{{ data.item.depositType }}</b-badge>
                                <div class="font-weight-bold">R{{ data.item.amount.toFixed(2) }}</div>
                            </span>
                            <span v-else class="text-muted">&mdash;</span>
                        </template>
                        <template #cell(reference)="data">
                            {{ data.item.reference }}
                        </template>
                        <template #cell(match)="data">
                            <b-badge v-if="!data.item.bank" variant="light">n/a</b-badge>
                            <b-badge v-else-if="data.item.matchType === 'Email' || data.item.matchType === 'Cellphone' || data.item.matchType === 'MerchantCode'"
                                variant="success">
                                {{ data.item.matchType }}: {{ data.item.matchedLabel }}
                            </b-badge>
                            <b-badge v-else-if="data.item.matchType === 'KnownPattern'" variant="warning">
                                Known: {{ data.item.matchedLabel }}
                            </b-badge>
                            <b-badge v-else variant="danger">
                                Unmatched
                            </b-badge>
                        </template>
                        <template #cell(agentCode)="data">
                            <span v-if="data.item.agentCode">{{ data.item.agentCode }}</span>
                            <span v-else class="text-muted">&mdash;</span>
                        </template>
                        <template #cell(depositRequestedOn)="data">
                            <!-- Automatically approved rows are acknowledged and move to Relayed Deposits, so any
                                 request still visible here wasn't approved automatically and needs a human. -->
                            <b-badge v-if="data.item.depositRequestedOn" variant="warning"
                                title="Not approved automatically - check the Un-Approved tab">
                                Check Un-Approved
                                <div>{{ data.item.depositRequestedOn | formateDate }}</div>
                            </b-badge>
                            <span v-else class="text-muted">&mdash;</span>
                        </template>
                        <template #cell(action)="data">
                            <b-button size="sm" pill variant="outline-success" @click="onAcknowledgeClick(data.item)">
                                Acknowledge
                            </b-button>
                        </template>
                    </b-table>
                    <br />
                    <b-pagination @input="handlePageClick" v-model="selectedPage" :total-rows="totalRecords"
                        :per-page="perPage" first-number last-number></b-pagination>
                    <span>Total records : {{ totalRecords }}</span>
                </b-col>
            </b-row>

            <b-overlay :show="busy" no-wrap>
                <template #overlay>
                    <div v-if="processing" class="text-center p-4 bg-primary text-light rounded">
                        <b-icon icon="cloud" font-scale="4"></b-icon>
                        <div class="mb-3">Processing...</div>
                        <div class="text-center">
                            <b-spinner type="grow" label="Spinning"></b-spinner>
                        </div>
                    </div>
                    <div
                        v-else
                        ref="dialog"
                        tabindex="-1"
                        role="dialog"
                        aria-modal="false"
                        aria-labelledby="form-confirm-label"
                        class="text-center p-3"
                    >
                        <p><strong id="form-confirm-label">Are you sure, you want to acknowledge this message?</strong></p>
                        <div class="d-flex">
                            <b-button variant="outline-danger" class="mr-3" @click="onCancel">
                                Cancel
                            </b-button>
                            <b-button variant="outline-success" @click="onOK">OK</b-button>
                        </div>
                    </div>
                </template>
            </b-overlay>

            <loading :active.sync="isLoading" :is-full-page="true"></loading>
        </div>
    </main>
</div>
